import type { FaireProductEntity } from "../../entity_types/product";

export const p_azpgbbqqqe: FaireProductEntity = {
  token: "p_azpgbbqqqe",
  type: "product",
  name: "Claddagh Bath Art Bomb - Rose, Orange & Neroli",
  brandToken: "b_6stwu69ae8",
  brandName: "Enniskinn - Handmade N.Irish Selfcare",
  imageUrl:
    "https://cdn.faire.com/fastly/fd32357f99009a8f48e905cc799e94420cf0e36df4b5909feae9fc46b7be7313.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c42a140fb514ff6855a0b0f331de2690f3da816ac5b2419b8e9e50100a777ddf.jpeg",
    "https://cdn.faire.com/fastly/5794708b67e0ed641fb45bc60210c3b4802998f724b2dcc3fc6be36f67f3f585.jpeg",
  ],
  priceDollars: 3.77,
  description:
    "For Mo Chroi\n\nSink into the spirit of the Claddagh — love, friendship and loyalty — with this skin-kind bath art bomb. Formulated without common irritants, our gentle blend features cocoa butter and apricot kernel oil for deep skin conditioning. A burst of rose, orange and neroli essential oils transforms your bath into a calming, mood-lifting ritual. Vegan. Free from synthetic fragrances, sulphates and skin irritants. Kindness — for your skin and your senses.\n\nCladdagh is a celebration of love, friendship, and loyalty; the bonds that ground us, comfort us and endure through every season of life. \n\nScent notes: Rose - Orange - Neroli\n\nThis bathbomb is suitable for sensitive skin as Enniskinn does not use any sulphates, parabens or nasty additives. \n\nImportant: Our bath bombs do not stain your bath tub It is however, still recommended you wipe down your bathtub after use.To avoid hand staining, please refrain from holding your bathbomb in the water for an extended period of time. Over time, air can cause the bathbomb to loose fizz. With this in mind, to ensure quality & freshness we will package your bathbombs air tight. \n\n\nHere at Enniskinn, we create everything in small batches. This means that we don't compromise on quality of products. Appearance may differ slightly between batches.\n\nHandmade in Northern Ireland \n\n\n\n",
  tags: [],
  msrpDollars: 8.18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:57.814Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
